import {NgModule} from '@angular/core';

import {SuccessAnimationComponent} from './success-animation.component';

@NgModule({
  declarations: [SuccessAnimationComponent],
  exports: [SuccessAnimationComponent]
})
export class SuccessAnimationModule {}
